import { useMutation } from '@tanstack/react-query';

import { PricingPlanTickRate } from 'src/features/pricingPlan/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/pricing/pricing-plan/:planId/pricing-plan-tick-rate/:tickRateId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    planId: string;
    tickRateId: string;
    parkingId: string;
}
const mutationFn = ({ planId, tickRateId, parkingId, ...params }: DTO): Promise<PricingPlanTickRate> => {
    return axios.put(formatResourcePath(RESOURCE, { planId, tickRateId, parkingId }), params);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdatePricingPlanTickRate };
